import { Link, useLocation } from "react-router-dom";
import { MessageCircle, FileText } from "lucide-react";
import { useSite, whatsappLink } from "../context/SiteContext";

const HIDDEN_ON = ["/contact", "/custom-solutions", "/admin"];

export const MobileActionBar = () => {
  const { settings } = useSite();
  const { pathname } = useLocation();
  if (HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;

  return (
    <div
      data-testid="mobile-action-bar"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-white/10 sm:hidden"
    >
      <Link
        to="/contact"
        data-testid="mobile-bar-quote"
        className="flex items-center justify-center gap-2 bg-[#0F4C81] py-4 text-[0.625rem] font-bold uppercase tracking-[0.18em] text-white"
      >
        <FileText className="h-4 w-4" />
        Request quote
      </Link>
      <a
        href={whatsappLink(settings)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-bar-whatsapp"
        className="flex items-center justify-center gap-2 bg-[#111111] py-4 text-[0.625rem] font-bold uppercase tracking-[0.18em] text-white"
      >
        <MessageCircle className="h-4 w-4" />
        WhatsApp
      </a>
    </div>
  );
};
